import { Collapse } from 'bootstrap';
import TabTrap from '../utils/tabTrap';

const HeaderQuickLinkMenu = (header) => {
    const quickLinks = header.querySelector('.quick-links-wrapper')
    const quickLinksCollapse = new Collapse(quickLinks, { toggle: false });
    const quickLinksTabTrap = new TabTrap(quickLinks);
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(quickLinks)
        if (!withinBoundaries) {
            quickLinksCollapse.hide();
        }
    })
    quickLinks.addEventListener('shown.bs.collapse', () => {
        quickLinksTabTrap.on();
    })
    quickLinks.addEventListener('hidden.bs.collapse', () => {
        quickLinksTabTrap.off();
    })
    quickLinks.addEventListener('tabtrapEscaped', () => {
        quickLinksCollapse.hide();
    })
}

export default HeaderQuickLinkMenu;